<template>
  <new-modal-dialog
    persistent
    width="550"
    max-width="550"
    scrollable
    container-class="pa-0 ma-0"
    card-class="pa-0 ma-0"
    content-class="dialog-height-60 pa-0 ma-0"
    @keydown.enter="emit('confirm', selection)"
    @keydown.esc="emit('dismiss')"
  >
    <template #title-append-outer>
      <v-card-title class="px-4">
        {{ $t('label.select_newsletter_recipients') }}
      </v-card-title>
      <v-card-subtitle class="pt-1 pb-2 px-4">
        {{ $t('label.select_newsletter_recipients_hint') }}
      </v-card-subtitle>
    </template>
    <v-list
      dense
    >
      <v-list-item-group
        v-model="selection"
        multiple
      >
        <template v-for="(item, i) in sortedRecipients">
          <v-divider
            v-if="!item"
            :key="`divider-${i}`"
          />

          <v-list-item
            v-else
            :key="`item-${i}`"
            :value="item.value"
          >
            <template #default="{ active }">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.value }}
                  <v-chip
                    v-if="currentUserEmail === item.value"
                    x-small
                    color="blue"
                    label
                    class="ml-4"
                    style="margin-bottom: 2px"
                  >
                    {{ $t('label.current_user') }}
                  </v-chip>
                </v-list-item-title>
                <v-list-item-subtitle>{{ item.text }}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-checkbox :input-value="active" />
              </v-list-item-action>
            </template>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
    <template #actions>
      <v-btn
        text
        @click="selectAll"
      >
        {{ $t('button.select_all') }}
      </v-btn>
      <v-spacer />
      <v-btn
        :disabled="selection.length === 0"
        color="green"
        @click="emit('confirm', selection)"
      >
        {{ $t('button.confirm') }}
      </v-btn>

      <v-btn
        color="error"
        text
        @click="emit('dismiss')"
      >
        {{ $t('button.cancel') }}
      </v-btn>
    </template>
  </new-modal-dialog>
</template>

<script lang="ts" setup>
import { computed, PropType, ref } from 'vue';
import NewModalDialog from '@/components/dialogs/NewModalDialog.vue';
import store from '@/store/store';
import User from '@/model/User';

// const emit = defineEmits(['confirm', 'dismiss']);
const emit = defineEmits<{(e: 'confirm', recipients: string[]): void
  (e: 'dismiss'): void
}>();

const props = defineProps({
  recipients: { type: Array as PropType<{text: string | undefined, value: string}[]>, required: true },
});

const currentUserEmail = computed(() => {
  const user = store.getters.activeUser as User | undefined;
  return user?.email;
});

const selection = ref([currentUserEmail.value] as string[]);

const sortedRecipients = computed(() => props.recipients.toSorted(
  (a, b) => (a.value === currentUserEmail.value ? -1 : a.value?.localeCompare(b.value)),
));

const selectAll = () => {
  selection.value = selection.value.length === props.recipients.length ? [] : props.recipients?.map((r) => r.value);
};

</script>
